var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0219727,
    y: 0.194824,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F1F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_15035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.022 25.1948V23.1948C24.022 22.134 23.6005 21.1165 22.8504 20.3664C22.1003 19.6163 21.0828 19.1948 20.022 19.1948H12.022C10.9611 19.1948 9.94369 19.6163 9.19355 20.3664C8.4434 21.1165 8.02197 22.134 8.02197 23.1948V25.1948",
    fill: "#97999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.022 15.1948C18.2311 15.1948 20.022 13.404 20.022 11.1948C20.022 8.98569 18.2311 7.19482 16.022 7.19482C13.8128 7.19482 12.022 8.98569 12.022 11.1948C12.022 13.404 13.8128 15.1948 16.022 15.1948Z",
    fill: "#97999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.022 25.1948V23.1948C24.022 22.134 23.6005 21.1165 22.8504 20.3664C22.1003 19.6163 21.0828 19.1948 20.022 19.1948H12.022C10.9611 19.1948 9.94369 19.6163 9.19355 20.3664C8.4434 21.1165 8.02197 22.134 8.02197 23.1948V25.1948M20.022 11.1948C20.022 13.404 18.2311 15.1948 16.022 15.1948C13.8128 15.1948 12.022 13.404 12.022 11.1948C12.022 8.98569 13.8128 7.19482 16.022 7.19482C18.2311 7.19482 20.022 8.98569 20.022 11.1948Z",
    stroke: "#97999B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02197 6.19482L26.022 27.1948",
    stroke: "#97999B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_15035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.02197 4.19482)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInactiveIcon);
export default __webpack_public_path__ + "static/media/UserInactiveIcon.54e2592729cde0776b7da4ca41793372.svg";
export { ForwardRef as ReactComponent };